<template>
    <div class="timeline">
        <ul class="timeline-list">
            <li class="timeline-item"
                v-for="(item, index) in steps"
                :key="index"
                v-bind:class="{ active: current ? current == (index + 1) : 0 }">
                <div class="inner">
                    <span class="bullet"></span>
                    <span class="title" v-text="item.title"></span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['labels', 'current'],
        data() {
            return {
                steps: []
            }
        },
        mounted(){
            this.setLabels()
        },
        methods: {
            setLabels() {
                let titles = this.labels.split(',');
                titles.forEach((item, key) => {
                    this.steps.push({
                        active: key === 0 ? true : false,
                        title: item
                    })
                })
            }
        }
    }

</script>
